import signInChat from "app/api/requests/Chat/signInChat";

export const LOGIN_CHAT_SUCCESS = "LOGIN_CHAT_SUCCESS";

export const loginChat = (data: { email: string, password: string }) => (dispatch: any): any => {
	return signInChat(data.email, data.password).then(token => {
		sessionStorage.setItem("chatToken", token);
		dispatch({ type: LOGIN_CHAT_SUCCESS, payload: token });
		return Promise.resolve(token);
	});
}
